import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import type { WritableComputedRef } from 'vue'
import { NOOP, initAliveStoreIds, kapixContext, remove } from 'kapix-components-vue3'
import blocArgPasDeFraisPasDeDemarchesAdministrativesComponentStoreCustom from './store.custom'

const storeName = 'blocArgPasDeFraisPasDeDemarchesAdministrativesComponent'
const customImplement: CustomStoreImplementationOptions = blocArgPasDeFraisPasDeDemarchesAdministrativesComponentStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function blocArgPasDeFraisPasDeDemarchesAdministrativesComponentFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        $parentPage: NOOP,
        $parentComponent: NOOP,
        // Constants,
        $constants: {},
        // Data,
        $data: {
          cetteFormationVous: undefined as Nullable<string>,
          votreEntreprisePeut: undefined as Nullable<string>
        },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      /* @ts-ignore: to allow override in your custom file */
      $cetteFormationVous (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.cetteFormationVous,
          set: (value) => {
            this.$data.cetteFormationVous = value
            this.$emit('update:cetteFormationVous', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $votreEntreprisePeut (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.votreEntreprisePeut,
          set: (value) => {
            this.$data.votreEntreprisePeut = value
            this.$emit('update:votreEntreprisePeut', value)
          }
        })
      },
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return blocArgPasDeFraisPasDeDemarchesAdministrativesComponentFactory(storeId)()
}

export const blocArgPasDeFraisPasDeDemarchesAdministrativesComponentRaw = blocArgPasDeFraisPasDeDemarchesAdministrativesComponentFactory()
export const blocArgPasDeFraisPasDeDemarchesAdministrativesComponent = () => blocArgPasDeFraisPasDeDemarchesAdministrativesComponentRaw() as MergeCustomStore<typeof blocArgPasDeFraisPasDeDemarchesAdministrativesComponentStoreCustom.instance>
